module.exports = "/assets/0bf0ab9a95719fbe27649544311d33be.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PK.png
// module id = 1719
// module chunks = 0